import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const IconProjectDelivery = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 28 28">
      <path
        d="M18.0015 6.38558C17.6622 6.14804 17.1945 6.23057 16.957 6.5699C16.7195 6.90924 16.802 7.37689 17.1413 7.61442L18.0015 6.38558ZM24 11.5V12.25C24.3274 12.25 24.6169 12.0377 24.7153 11.7255C24.8137 11.4133 24.6983 11.0733 24.4301 10.8856L24 11.5ZM4 10.75C3.58579 10.75 3.25 11.0858 3.25 11.5C3.25 11.9142 3.58579 12.25 4 12.25V10.75ZM17.1413 7.61442L23.5699 12.1144L24.4301 10.8856L18.0015 6.38558L17.1413 7.61442ZM24 10.75H4V12.25H24V10.75Z"
        fill="#2E434D"
      />
      <path
        d="M9.99847 21.6144C10.3378 21.852 10.8055 21.7694 11.043 21.4301C11.2805 21.0908 11.198 20.6231 10.8587 20.3856L9.99847 21.6144ZM4 16.5V15.75C3.67265 15.75 3.38311 15.9623 3.2847 16.2745C3.18628 16.5867 3.30173 16.9267 3.5699 17.1144L4 16.5ZM24 17.25C24.4142 17.25 24.75 16.9142 24.75 16.5C24.75 16.0858 24.4142 15.75 24 15.75V17.25ZM10.8587 20.3856L4.4301 15.8856L3.5699 17.1144L9.99847 21.6144L10.8587 20.3856ZM4 17.25H24V15.75H4V17.25Z"
        fill="#2E434D"
      />
    </SvgIcon>
  );
};

export default IconProjectDelivery;
